import { render } from "./ContentBlock.vue?vue&type=template&id=3212077b&scoped=true&ts=true"
import script from "./ContentBlock.vue?vue&type=script&lang=ts"
export * from "./ContentBlock.vue?vue&type=script&lang=ts"

import "./ContentBlock.vue?vue&type=style&index=0&id=3212077b&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3212077b"]])

export default __exports__